import React, { FC } from 'react';
import { Icon, IconProps } from '../icon';
import { Stack } from '../stack';

export type LoadingIndicatorProps = {
  size?: IconProps['size'];
  color?: IconProps['color'];
};

export const LoadingIndicator: FC<LoadingIndicatorProps> = ({
  size,
  color = 'primary',
}) => {
  return (
    <Stack fill align="center">
      <Icon color={color} size={size} icon={['fas', 'spinner']} spin />
    </Stack>
  );
};
